import React from "react";
// import { ContentWithCardLoading } from "../../components/loading";
import { Route, Switch } from "react-router-dom";
import SenderIdList from "./container/senderId-list";

export default function SenderIdsRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.url}/`} component={SenderIdList} />
    </Switch>
  );
}
